<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :rules="rules" :inline="true">
        <div class="block">
          <div class="contit">基础信息</div>
          <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">装货信息</div>
          <FormItem v-for="(c, i) in formCtrlIn" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">卸货信息</div>
          <FormItem v-for="(c, i) in formCtrlOut" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">运单信息</div>

          <FormItem v-for="(c, i) in formCtrlOrder.slice(0, 3)" :key="'formItemO' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

          <div v-show="form.pricing_id != 5">
            <FormItem v-for="(c, i) in formCtrlOrder.slice(3)" :key="'formItemO3' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

            <!-- 亏吨重量控件 -->
            <span>
              <FormItem v-show="form.pricing_id == 1" :viewMode="kuitonCtrl.viewMode" :config="kuitonCtrl"
                :options="kuitonCtrl.options" :inputValue="form[kuitonCtrl.keyName]" @onChange="onChange" />
            </span>
          </div>
          
          <div>
            <FormItem v-for="(c, i) in formCtrlOrder2" :key="'formO2Item' + i" :viewMode="c.viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </div>

          <FormItem v-for="(c, i) in formCtrl2" :key="'form2Item' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange">
            <template #end>
              <PaymentSwitch v-show="form['repaytime']" :value="form['istime']" @onToggle="onToggle" />
            </template>
          </FormItem>

          <!-- 可变文本域备注 -->
          <FormItem v-for="(c, i) in formCtrl3" :key="'form3Item' + i" :ref="'form3Item' + i" :viewMode="c.viewMode"
            :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" @onInput="onInput">
          </FormItem>
        </div>

        <ExtraFee :form="form" :formCtrl="formCtrlfee" @onChange="onChange" />
      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn :editMode="true" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import orderViewMixin from "../orderViewMixin";
import nonOrderViewMixin from "./nonOrderViewMixin";

export default {
  mixins: [detailMixin, orderViewMixin, nonOrderViewMixin],
  data() {
    return {
      baseUrl: 'order',
      breadcrumb: [
        { name: "运单管理", path: "/order/nocontract" },
        { name: "普通运单", path: "/order/nocontract" },
        { name: "运单添加" },
      ],
    };
  },
  methods: {},
  created() {
    // const { user_group_id } = this.user
    // if (user_group_id == 5) {
    //   this.formCtrlOrder2.map(v => {
    //     v.viewMode = false
    //   })
    // }
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.unton {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-date-editor--daterange {
        width: 300px;
      }

      .el-form-item__content {
        .el-input {
          width: 300px;
        }

        .unit {
          color: #909399;
        }

        .switch {
          margin-left: 10px;

          .el-switch {
            display: block;

            .el-switch__core {
              margin: 2px auto;
              display: block;
            }

            &.inactive {
              .el-switch__core::after {
                content: '关';
                line-height: 17px;
                text-indent: 18px;
                color: #fff;
              }
            }

            &.active {
              .el-switch__core::after {
                content: '开';
                line-height: 17px;
                text-indent: -16px;
                color: #fff;
              }
            }
          }

          .txt {
            min-width: 50px;
            line-height: 16px;
            font-size: 12px;
            color: #909399;
            margin-top: 3px;
          }
        }
      }

    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  margin: 40px 0 60px 180px;
}
</style>